import {IController} from "angular";
import * as angular from "angular";
import * as _ from "lodash";
import {RoutesService} from "../../../routes/services/routes-service.service";
import {ExportType} from "../../types/export.type";
import {RouteModel} from "../../../routes/models/route.model";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {TaskType} from "../../../tasks/types/task.type";
import {LeanPlanningService} from "../../services/lean-planning-service.service";

export class dispatchedRoutesActionButtonCtrl implements IController {
  excludeMode: any;
  allRoutesCount: any;
  selectedIds: any;
  onAssign: Function;
  onMerge: Function;
  onReset: Function;
  onDelete: Function;
  onExport: Function;
  onExportIntegration: Function;
  onUpdateBranches: Function;

  public siteId: any;
  public allowPrintingBillOfLading: boolean;
  public routesRef: any;
  public routesMenu: any;
  public enabledActions: any;
  public integrationExportRouteEnabled: boolean;
  public exportType: typeof ExportType = ExportType;
  public printerProvider: string;
  public routes: RouteModel[];
  public deliveriesRef: any;
  public taskTypes: typeof TaskType = TaskType;

  constructor(private splitService, private $planningRoutes, private $deliveries, private commonsDialogService: CommonsDialogService,
              private routesService: RoutesService, private leanPlanningService: LeanPlanningService) {
    this.siteId = this.splitService.getSiteId();
    this.allowPrintingBillOfLading = this.splitService.isPrintingBillOfLadingAllowed();
    this.routesRef = this.$planningRoutes();
    this.integrationExportRouteEnabled = this.splitService.getSiteIntegrationExportRouteEnabled();
    this.printerProvider = this.splitService.getPrinterProvider();
    this.deliveriesRef = this.$deliveries();

  }

  onOpen($mdMenu, $event) {
    this._getSelectedRoutes()
      .then((routes: RouteModel[]) => {
        this.routes = routes;
        this.enabledActions = this.leanPlanningService.getRoutesActionsMap(routes);

      })

    $mdMenu.open($event);
  }

  onPrint() {
    this.routesService.printRoutes(this.selectedIds);
  }

  onPrintIkea() {
    let serviceIds = [];
    this.routes.forEach((r) => {
      serviceIds = serviceIds.concat(_.uniq(r.routeTaskList.filter(t => t.taskType === this.taskTypes.Stopover).map(t => t.serviceId)));
    })
    this.deliveriesRef.$asyncValues(serviceIds)
      .then((services) => {
        this.commonsDialogService.printIkea(services);
      })
  }

  onPrintLoadingSheet() {
    this.routesService.printLoadingSheet(this.selectedIds);
  }

  onPrintBillOfLading() {
    this.routesService.onPrintBOL(this.selectedIds);
  }

  onDownloadBillOfLading() {
    this.routesService.onDownloadBOL(this.selectedIds);
  }

  private _getSelectedRoutes() {
    return this.routesRef.$asyncValues(this.selectedIds);
  }
}


angular
  .module('bringoz.admin.lean-planning')
  .component('dispatchedRoutesActionButton', {
    bindings: {
      excludeMode: '<',
      allRoutesCount: '<?',
      displayAsIcon: '<?',
      selectedIds: '<',
      onAssign: '&',
      onMerge: '&',
      onReset: '&',
      onDelete: '&',
      onExport: '&',
      onExportIntegration: '&',
      onUpdateBranches: '&'
    },
    template: require('./dispatched-routes-action-button.html').default,
    controller: dispatchedRoutesActionButtonCtrl
  });
